import { useUserDetailsStore } from "..";
import { DPButton } from "../../../common/types";
import SubscribeButtonC from "../../../components/SubscribeButtonC";
import { fetchSubscribe } from "../api";

interface Props extends DPButton {}

const SubscribeButton = (props: Props) => {
  const isLoading = useUserDetailsStore((s) => s.isSubscribeButtonLoading);
  const isSubscribed = useUserDetailsStore((s) => s.user.isSubscribed);

  const handleClick = async () => {
    fetchSubscribe();
  };

  return (
    <SubscribeButtonC
      disabled={isLoading}
      onClick={handleClick}
      isSubscribed={isSubscribed}
    />
  );
};

export default SubscribeButton;
